// PrivacyPolicy.js
import React from "react";

function PrivacyPolicy() {
  return (
    <div className="content">
      <h1>Privacy Policy</h1>
      <ol>
        <li>
          <strong>Introduction</strong> <br /> Welcome to dayê. LoRên IT is
          committed to protecting and respecting your privacy.
        </li>
        <li>
          <strong>Contact Information</strong> <br /> For assistance or
          questions, email us at support@loren-it.com.
        </li>
        <li>
          <strong>Information We Collect</strong>
          <ul>
            <li>
              <strong>Account Information</strong>: Email address.
            </li>
            <li>
              <strong>Usage Data</strong>: Data from account creation, course
              achievements, and lesson progress.
            </li>
            <li>
              <strong>Audio Submissions</strong>: Audio recordings submitted by
              users for language learning purposes.
            </li>
          </ul>
        </li>
        <li>
          <strong>How We Use Your Data</strong>
          <ul>
            <li>To improve and personalize dayê.</li>
            <li>To track learning progress and optimize content.</li>
            <li>
              To utilize audio submissions for enhancing Kurdish language
              learning tools.
            </li>
          </ul>
        </li>
        <li>
          <strong>Storage & Protection</strong>
          <ul>
            <li>
              <strong>Data Storage</strong>: Data is stored in Google Firebase's
              Cloud Firestore in Europe.
            </li>
            <li>
              <strong>Protection</strong>: Data is safeguarded by Google.
            </li>
            <li>
              <strong>Audio Data</strong>: All audio recordings are stored
              anonymously without linking to personal information.
            </li>
          </ul>
        </li>
        <li>
          <strong>User Rights</strong>
          <ul>
            <li>Users can modify or delete their data and accounts.</li>
            <li>Users can request deletion of their audio submissions.</li>
          </ul>
        </li>
        <li>
          <strong>Third-Party Integration</strong> <br /> Users can log in using
          Google or Apple accounts. No data is shared with these third parties
          other than what is required for operation.
        </li>
        <li>
          <strong>Updates</strong> <br /> We may update our data practices
          periodically. Significant changes will be communicated.
        </li>
        <li>
          <strong>Acceptance</strong> <br /> By using dayê, you agree to the
          collection and use of your information according to this policy.
        </li>
        <li>
          <strong>Audio Submissions</strong>
          <ol>
            <li>
              <strong>User Anonymity</strong> <br /> Audio recordings submitted
              by users are stored without any identifiable information. LoRên IT
              ensures that these recordings cannot be traced back to individual
              users, maintaining complete anonymity.
            </li>
            <li>
              <strong>Prohibited Content</strong> <br /> Submitting audio
              recordings that contain violent, harmful, offensive, or
              inappropriate content is strictly prohibited. This includes, but
              is not limited to, recordings that use vocabulary incorrectly with
              malicious intent or include explicit, hateful, or abusive
              language. Any violation of these content guidelines may result in
              the immediate deletion of the audio submission and potential
              termination of the user's account.
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
}

export default PrivacyPolicy;
